import React, {Component} from 'react';
import PropTypes from 'prop-types';

const Pagination = props => {
  
  let goToPage = function(page, e){
    e.preventDefault();
    props.goTo(page);
  };
  let goToFirst = function(e){
    e.preventDefault();
    props.goTo(1);
  };
  let goToLast = function(e){
    e.preventDefault();
    props.goTo(numOfPages);
  };
  let goToNext = function(e){
    e.preventDefault();
    props.goTo(++currentPage);
  };
  let goToPrevious = function(e){
    e.preventDefault();
    props.goTo(--currentPage);
  };
  
  let currentPage = props.currentPage;
  let itemCount = parseInt(props.totalItems);
  let pageSize = 50;
  let numOfPages = Math.ceil(itemCount/ pageSize);
  let pagesToShow = 5;
  let items = [];
  
  let firstNum = 1;
  let lastNum = 10;
  let ceil = Math.ceil(pagesToShow/2);
  
  let showBeginningEllipse = false; 
  let showEndEllipse = false; 
  
  if(numOfPages < pagesToShow){
    firstNum = 1;
    lastNum = numOfPages;
    showBeginningEllipse = false;
    showEndEllipse = false;
  } else if(currentPage <= ceil){
    firstNum = 1;
    lastNum = pagesToShow;
    showEndEllipse = true;
  } else if (currentPage >= numOfPages - ceil) {
    showBeginningEllipse = true;
    firstNum = numOfPages - pagesToShow;
    lastNum =  numOfPages;
  } else {
    firstNum = currentPage - ceil + 1; 
    lastNum =  currentPage + ceil -1 ;
    showBeginningEllipse = true;
    showEndEllipse = true;
  }

  for(let i = firstNum; i <= lastNum; i++){
    if(i === currentPage){
      items.push(<li key={i} className="page-item active"><a className="page-link" href="" onClick={(e) => {goToPage(i, e)}}>{i}</a></li>)
    } else {
      items.push(<li key={i} className="page-item"><a className="page-link" href="" onClick={(e) => {goToPage(i,e)}}>{i}</a></li>)
    }
  }
  
  let isFirstDisabled = currentPage === 1? "disabled": "";
  let isLastDisabled = currentPage === numOfPages? "disabled": "";
  
  return (
    <nav aria-label="User navigation">
      <ul className="pagination">
        <li className={"page-item " + isFirstDisabled} onClick={goToPrevious}>
          <a className="page-link" href="#" tabIndex="-1" aria-disabled="true">Previous</a>
        </li>
        { showBeginningEllipse && <li className="page-item">
          <a className="page-link" href="#" aria-label="Go To First Page"  onClick={goToFirst}>
            <span aria-hidden="true">1</span>
          </a>
        </li>}
        { showBeginningEllipse && <li className="page-item disabled">
          <a className="page-link" href="#" aria-label="Previous">
            <span aria-hidden="true">...</span>
          </a>
        </li>}
        {items}
        {showEndEllipse && <li className="page-item disabled">
          <a className="page-link" href="#" aria-label="Previous">
            <span aria-hidden="true">...</span>
          </a>
        </li>}
        {showEndEllipse && <li className="page-item">
          <a className="page-link" href="#" aria-label="Go To Last Page" onClick={goToLast}>
            <span aria-hidden="true">{numOfPages}</span>
          </a>
        </li>}
        <li className={"page-item " + isLastDisabled}>
          <a className="page-link" href="" aria-label="Next" onClick={goToNext}>
            <span aria-hidden="true">Next</span>
          </a>
        </li>
      </ul>
    </nav>
  );
};

Pagination.propTypes = {
  goTo: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalItems: PropTypes.any.isRequired,
};

export default Pagination;
